import { render, staticRenderFns } from "./CardPartner.vue?vue&type=template&id=0bafb5fa&scoped=true&"
import script from "./CardPartner.vue?vue&type=script&lang=js&"
export * from "./CardPartner.vue?vue&type=script&lang=js&"
import style0 from "./CardPartner.vue?vue&type=style&index=0&id=0bafb5fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bafb5fa",
  null
  
)

export default component.exports